import { useMutation } from "@/api/utils/useQuery"
import {
  BackofficeRestMutations,
  StorePsrPayload,
} from "@/api/backofficeRest/mutations"
import { MutationResult } from "@/api/utils/types"
import {
  IStorePsr,
  IStorePsrCustomerService,
  IStorePsrCustomerServiceExtraData,
  IStorePsrCustomerVulnerability,
} from "@/mutators/psr/PsrMutator.types"
import {
  PsrCustomerService,
  PsrCustomerVulnerability,
  PsrExtraDataField,
} from "@/api/backofficeRest/generated/model"

export interface IPsrMutator {
  storeVulnerabilitiesAndAssociatedServices(): MutationResult<IStorePsr, void>
}

export class PsrMutatorClass implements IPsrMutator {
  storeVulnerabilitiesAndAssociatedServices() {
    return useMutation({
      ...BackofficeRestMutations.psr.store(),
      serializerFn: (data: IStorePsr): StorePsrPayload => {
        const customerServices: Array<PsrCustomerService> =
          data.input.customerServices.map(
            (customerService: IStorePsrCustomerService) => {
              const extraData: Array<PsrExtraDataField> | undefined =
                customerService.extraData?.map(
                  (serviceItem: IStorePsrCustomerServiceExtraData) => {
                    return {
                      id: serviceItem.id,
                      field: serviceItem.field,
                      value: serviceItem.value,
                    }
                  },
                )
              return {
                extraData,
                id: customerService.id,
                startDate: customerService.startDate,
                endDate: customerService.endDate,
              }
            },
          )
        const customerVulnerabilities: Array<PsrCustomerVulnerability> =
          data.input.customerVulnerabilities.map(
            (vulnerability: IStorePsrCustomerVulnerability) => {
              return {
                endDate: vulnerability.endDate,
                id: vulnerability.id,
                startDate: vulnerability.startDate,
                note: vulnerability.note,
              }
            },
          )

        return {
          customerId: data.customerId,
          body: {
            accountId: data.input.accountId,
            customerServices,
            customerVulnerabilities,
          },
        }
      },
      invalidateCache: false,
    })
  }
}

export const PsrMutator = new PsrMutatorClass()
